import React from "react";
import Header from "../Section/Header";
import HeroSection from "../Section/HeroSection";
import ExploreVedic from "../Section/ExploreVedic";
import Footer from "../Section/Footer";
const Home = () => {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-indigo-900 bg-[length:300%_300%] animate-gradient-flow">
        <HeroSection />

        {/* Explore Vedic Wisdom */}
        <ExploreVedic />

        <Footer />
      </div>
    </>
  );
};

export default Home;
